<template>
  <div class="licence-view">
    <v-container>
      <v-card class="mt-6 elevation-4" style="border-radius: 12px; overflow: hidden;">
        <v-card-title class="page-head">
          <div class="ph-left">
            <div class="ph-icon"><v-icon color="#4527a0">mdi-file-certificate</v-icon></div>
            <div>
              <div class="ph-title">Licences</div>
              <div class="ph-sub">Manage care giver licence files</div>
            </div>
          </div>
          <v-spacer />
          <v-btn class="ph-btn" @click="openNew">
            <v-icon left small>mdi-plus</v-icon>
            New Licence
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-row class="mb-3">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                label="Search"
                dense
                outlined
                prepend-inner-icon="mdi-magnify"
                hide-details
              />
            </v-col>
          </v-row>

          <v-data-table
            :headers="headers"
            :items="licences"
            :search="search"
            :items-per-page="-1"
            :footer-props="{ 'items-per-page-options': [10, 25, 50, -1], 'items-per-page-text': 'Rows per page' }"
            class="elevation-0"
          >
            <template v-slot:item.index="{ index }">
              <span class="cell-muted">{{ index + 1 }}</span>
            </template>

            <template v-slot:item.mothername="{ item }">
              <span class="cell-name">{{ item.mothername }}</span>
            </template>

            <!-- Mother image avatar -->
            <template v-slot:item.motherimage="{ item }">
              <v-avatar size="38" class="avatar-ring">
                <v-img v-if="item.motherimage" :src="fileUrl(item.motherimage)" />
                <v-icon v-else color="#90a4ae">mdi-account-heart</v-icon>
              </v-avatar>
            </template>

            <!-- Download button for licence file -->
            <template v-slot:item.filelicence="{ item }">
              <v-btn
                v-if="item.filelicence"
                small
                outlined
                color="primary"
                :href="fileUrl(item.filelicence)"
                target="_blank"
                :download="basename(item.filelicence)"
              >
                <v-icon left small>mdi-file-download</v-icon>
                Download
              </v-btn>
              <span v-else class="cell-muted">No file</span>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small color="#2e7d32" v-bind="attrs" v-on="on" @click="edit(item)">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Edit licence</span>
              </v-tooltip>
            </template>

            <template v-slot:no-data>
              <div class="empty-state">
                <v-icon size="44" color="#b0bec5">mdi-file-certificate-outline</v-icon>
                <div class="empty-text">No licences found</div>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- Dialog for create / edit -->
      <v-dialog v-model="dialog" max-width="600px" persistent>
        <v-card>
          <div class="dlg-head">
            <div class="dlg-head-icon">
              <v-icon color="#fff">{{ dialogMode === 'create' ? 'mdi-file-certificate' : 'mdi-file-document-edit' }}</v-icon>
            </div>
            <div>
              <div class="dlg-title">{{ dialogMode === 'create' ? 'New Licence' : 'Edit Licence' }}</div>
              <div class="dlg-sub">{{ dialogMode === 'create' ? 'Upload a care giver licence' : 'Update licence details' }}</div>
            </div>
            <v-spacer />
            <v-btn icon small class="dlg-close" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
          </div>
          <v-card-text class="pt-5">
            <v-form ref="form">
              <div class="form-section">Licence Details</div>
              <v-row dense>
                <v-col cols="12" md="6">
                  <label class="cell-muted d-block mb-1">Care Giver</label>
                  <Select2
                    v-model="form.mother_id"
                    :options="motheroption"
                    id="motherid"
                    :settings="{ width: '100%' }"
                    @change="changedLabel3"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.licence_date"
                    label="Licence Date"
                    type="date"
                    outlined
                    dense
                    prepend-inner-icon="mdi-calendar"
                    required
                  />
                </v-col>
              </v-row>

              <div class="form-section">Licence File</div>
              <v-row dense>
                <v-col cols="12">
                  <v-file-input
                    accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                    label="Licence file"
                    prepend-icon="mdi-file-upload-outline"
                    outlined
                    dense
                    show-size
                    @change="onFileChange"
                  />
                  <v-text-field
                    v-model="form.filelicence"
                    label="Stored file name"
                    readonly
                    outlined
                    dense
                    prepend-inner-icon="mdi-file-check-outline"
                    class="mt-1"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="dlg-actions">
            <v-spacer></v-spacer>
            <v-btn text @click="dialog = false">Cancel</v-btn>
            <v-btn color="#0d2d63" dark @click="save">
              <v-icon left small>mdi-content-save-outline</v-icon>
              {{ dialogMode === 'create' ? 'Save Licence' : 'Save Changes' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import Select2 from 'v-select2-component';

const API_URL = process.env.VUE_APP_API_URL;
const API_URL_MOTHERS = process.env.VUE_APP_API_URL;
const UPLOAD_URL = process.env.VUE_APP_UPLOAD_URL;
const IMAGE_BASE_MOTHERS = process.env.VUE_APP_IMAGE_BASE;

export default {
  name: 'LicenceVue',
  components: {
    Select2,
  },
  data() {
    return {
      search: '',
      dialog: false,
      dialogMode: 'create', // 'create' | 'edit'
      licences: [],
      motheroption: [],
      uploadBaseUrl: IMAGE_BASE_MOTHERS,
      form: {
        id: null,
        filelicence: '',
        mother_id: null,
        licence_date: '',
      },
      headers: [
        { text: 'No', value: 'index' },
        {text:'Care Giver', value:'mothername'},
        {text:'Contanct', value:'contact'},
        {text:'sex', value:'sex'},
        {text:'mother image', value:'motherimage'},
        { text: 'File', value: 'filelicence' },
        { text: 'Licence Date', value: 'licence_date' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  mounted() {
    this.fetchLicences();
    this.fetchmother();
  },
  methods: {
    async onFileChange(file) {
      if (!file) return;
      const formData = new FormData();
      formData.append('file', file);
      try {
        const res = await axios.post(UPLOAD_URL, formData);
        // assuming upload.php returns just the stored filename
        this.form.filelicence = res.data;
      } catch (err) {
        console.error('Failed to upload licence file', err);
      }
    },
    async fetchLicences() {
      try {
        const res = await axios.post(API_URL, {
          opcion: 17,
          id: null,
          filelicence: null,
          mother_id: null,
          licence_date: null,
          op: 0,
          usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '',
        });
        // Expecting { success: true, data: [...] }
        const payload = res.data || {};
        this.licences = Array.isArray(payload.data) ? payload.data : [];
      } catch (e) {
        console.error('Failed to fetch licences', e);
        this.licences = [];
      }
    },
    // Build absolute URL for stored files (image and licence)
    fileUrl(name) {
      if (!name) return '#';
      const s = String(name);
      if (/^https?:\/\//i.test(s)) return s;
      return this.uploadBaseUrl + s.replace(/^\/+/, '');
    },
    // Get display file name from a path
    basename(name) {
      if (!name) return '';
      return String(name).split('/').pop();
    },
    changedLabel3(event) {
      this.form.mother_id = event;
    },
    fetchmother() {
      axios
        .post(API_URL_MOTHERS, { opcion: 18, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '' })
        .then((response) => {
          this.motheroption = response.data || [];
        })
        .catch((e) => {
          console.error('Failed to fetch mothers', e);
          this.motheroption = [];
        });
    },
    openNew() {
      this.dialogMode = 'create';
      this.form = {
        id: null,
        filelicence: '',
        mother_id: null,
        licence_date: '',
      };
      this.dialog = true;
    },
    edit(item) {
      this.dialogMode = 'edit';
      this.form = {
        id: item.id,
        filelicence: item.filelicence,
        mother_id: item.mother_id,
        licence_date: item.licence_date,
      };
      this.dialog = true;
    },
    async save() {
      if (this.dialogMode === 'create') {
        await this.createLicence();
      } else {
        await this.updateLicence();
      }
      this.dialog = false;
      this.fetchLicences();
    },
    async createLicence() {
      const payload = {
        opcion: 17,
        id: this.form.id,
        filelicence: this.form.filelicence,
        mother_id: this.form.mother_id,
        licence_date: this.form.licence_date,
        op: 1,
        usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '',
      };
      console.log(payload,"waa xokta")
      try {
       const a= await axios.post(API_URL, payload);
       console.log(a);
      } catch (e) {
        console.error('Failed to create licence', e);
      }
    },
    async updateLicence() {
      const payload = {
        opcion: 17,
        id: this.form.id,
        filelicence: this.form.filelicence,
        mother_id: this.form.mother_id,
        licence_date: this.form.licence_date,
        op: 3,
        usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '',
      };
      try {
        await axios.post(API_URL, payload);
      } catch (e) {
        console.error('Failed to update licence', e);
      }
    },
  },
};
</script>

<style scoped>
.licence-view {
  margin-top: 16px;
}
</style>
